import PageLayout from '@/components/shared/PageLayout';
import ClientsPageContent from '@/components/clients/clients-page-content';

export default function ClientsPage() {
  return (
    <PageLayout
      title="Clients"
      subtitle="Manage your clients and their assessments"
    >
      <ClientsPageContent />
    </PageLayout>
  );
}